import React from 'react';
import AuthService from './authService.js';
import TpLocationItem from '../Domain/TpLocationItem.js';
import SearchParams from '../Elements/SearchParams';
import TpLocationSearchParams from '../Contents/ThirdParty/TpLocation/TpLocationSearchParams';

export default class TpLocationService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpLocationSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpLocation/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpLocationItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
